import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import './BlogPage.css';
import BLOG_POST_META from './blogPostMeta.json';

// 상세 본문은 BlogPostPage가 관리한다. 제목·요약은 blogPostMeta.json 에서 붙인다.
const BLOG_POSTS = [
  {
    id: 11,
    author: '왓퀴즈 에디터',
    date: '2026-03-06',
    category: '신기능 안내',
    readTime: '8분',
    featured: true,
  },
  {
    id: 10,
    author: '왓퀴즈 에디터',
    date: '2026-03-06',
    category: '신기능 안내',
    readTime: '7분',
    featured: true,
  },
  {
    id: 9,
    author: '왓퀴즈 에디터',
    date: '2026-03-06',
    category: '신기능 안내',
    readTime: '8분',
    featured: true,
  },
  {
    id: 8,
    author: '왓퀴즈 에디터',
    date: '2025-06-23',
    category: '실전 노하우',
    readTime: '15분',
    featured: true,
  },
  {
    id: 7,
    author: '왓퀴즈 에디터',
    date: '2026-11-05',
    category: '실전 노하우',
    readTime: '8분',
    featured: true,
  },
  {
    id: 'digital-literacy-classroom',
    author: '왓퀴즈 에디터',
    date: '2025-01-05',
    category: '교육법',
    readTime: '10분',
    featured: false,
  },
  {
    id: 'ai-worksheet-creation-tips',
    author: '왓퀴즈 에디터',
    date: '2025-01-10',
    category: '튜토리얼',
    readTime: '8분',
    featured: false,
  },
  {
    id: 1,
    author: '왓퀴즈 에디터',
    date: '2025-01-27',
    category: '실전 노하우',
    readTime: '10분',
    featured: true,
  },
  {
    id: 2,
    author: '왓퀴즈 에디터',
    date: '2025-01-25',
    category: '실전 노하우',
    readTime: '10분',
    featured: false,
  },
  {
    id: 3,
    author: '왓퀴즈 에디터',
    date: '2025-01-23',
    category: '학생 지도',
    readTime: '9분',
    featured: false,
  },
  {
    id: 4,
    author: '왓퀴즈 에디터',
    date: '2025-01-21',
    category: '학급 경영',
    readTime: '11분',
    featured: false,
  },
  {
    id: 5,
    author: '왓퀴즈 에디터',
    date: '2025-01-19',
    category: '교사 웰빙',
    readTime: '8분',
    featured: false,
  },
  {
    id: 6,
    author: '왓퀴즈 에디터',
    date: '2025-01-17',
    category: '미래 교육',
    readTime: '7분',
    featured: false,
  },
].map((post) => ({ ...post, ...BLOG_POST_META[post.id] }));

const formatPostDate = (dateString) => {
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return dateString;

  return date.toLocaleDateString('ko-KR', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
};

const BlogPage = () => {
  const featuredPosts = BLOG_POSTS.filter((post) => post.featured);

  return (
    <div className="blogpage-page">
      <Helmet>
        <title>교사 블로그 | AI PPT · 학습지 · 이미지 · 생기부 활용 가이드 | 왓퀴즈</title>
        <meta
          name="description"
          content="교사를 위한 AI 활용 가이드. AI PPT 만들기, 학습지 자동 생성, 이미지 생성, 생기부 작성, 수행평가 채점 등 실전 팁. 현직 교사들의 경험과 노하우를 공유합니다."
        />
        <meta
          name="keywords"
          content="교사 블로그, AI PPT 만들기, 학습지 만들기, AI 이미지 생성, 생기부 AI, 수행평가 채점, 교육 AI 가이드, 교사 전용 AI, 교사 업무 자동화, 왓퀴즈 블로그"
        />
        <link rel="canonical" href="https://whatquiz.co.kr/blog" />

        <meta
          property="og:title"
          content="교사 블로그 | AI PPT · 학습지 · 이미지 · 생기부 활용 가이드 | 왓퀴즈"
        />
        <meta
          property="og:description"
          content="AI PPT 만들기, 학습지 생성, 이미지 생성, 생기부 작성 등 교사를 위한 실전 AI 활용 가이드."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://whatquiz.co.kr/blog" />
        <meta property="og:image" content="https://whatquiz.co.kr/og-image-whatquiz-2025.png" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="교사 블로그 | AI PPT · 학습지 · 이미지 활용 가이드 | 왓퀴즈"
        />
        <meta
          name="twitter:description"
          content="AI PPT 만들기, 학습지 생성, 이미지 생성, 생기부 작성 등 교사 AI 활용 팁을 공유합니다."
        />
        <meta name="twitter:image" content="https://whatquiz.co.kr/og-image-whatquiz-2025.png" />

        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Blog',
            name: '왓퀴즈 교사용 블로그',
            description: 'AI PPT 만들기, 학습지 생성, 이미지 생성, 생기부 작성 등 교사를 위한 AI 활용 가이드와 실전 팁을 제공하는 교사 전용 블로그',
            url: 'https://whatquiz.co.kr/blog',
            publisher: {
              '@type': 'Organization',
              name: '플랙티컬 주식회사',
              url: 'https://whatquiz.co.kr',
            },
            blogPost: featuredPosts.map((post) => ({
              '@type': 'BlogPosting',
              headline: post.title,
              description: post.excerpt,
              url: `https://whatquiz.co.kr/blog/${post.id}`,
              datePublished: post.date,
              author: {
                '@type': 'Person',
                name: post.author,
              },
            })),
          })}
        </script>
      </Helmet>

      <main className="blogpage-container">
        <header className="blogpage-hero">
          <p className="blogpage-eyebrow">교사 실전 가이드</p>
          <h1 className="blogpage-title">교사를 위한 AI 활용 가이드</h1>
          <p className="blogpage-description">
            수업 자료부터 생기부까지, 교육 현장에서 바로 적용할 수 있는
            AI 활용법과 교사 노하우를 정리했어요.
          </p>
        </header>

        <section aria-labelledby="blogpage-latest">
          <h2 id="blogpage-latest" className="blogpage-section-title">최신 글</h2>
          <div className="blogpage-grid">
            {BLOG_POSTS.map((post) => (
              <article key={post.id} className="blogpage-card">
                <Link to={`/blog/${post.id}`} className="blogpage-card-link">
                  <div className="blogpage-card-top">
                    <span className="blogpage-category">{post.category}</span>
                    {post.featured && <span className="blogpage-featured">추천</span>}
                  </div>

                  <h3 className="blogpage-card-title">{post.title}</h3>
                  <p className="blogpage-card-excerpt">{post.excerpt}</p>

                  <div className="blogpage-card-meta">
                    <span className="blogpage-card-author">
                      {post.author} · {post.readTime} 읽기
                    </span>
                    <time className="blogpage-card-date" dateTime={post.date}>
                      {formatPostDate(post.date)}
                    </time>
                  </div>
                </Link>
              </article>
            ))}
          </div>
        </section>

        <section className="blogpage-cta">
          <h2>읽은 내용을 바로 활용해보세요</h2>
          <p>왓퀴즈 AI와 대화하며 수업 자료와 문서를 바로 만들 수 있어요.</p>
          <div className="blogpage-cta-actions">
            <Link to="/chat" className="blogpage-cta-primary">AI 상담 시작하기</Link>
            <Link to="/help" className="blogpage-cta-secondary">고객센터</Link>
          </div>
        </section>
      </main>
    </div>
  );
};

export default BlogPage;
